export enum UserRole {
  UNDEFINED = "undefined",
  SUPER_ADMIN = "superAdmin",
  ADMIN = "admin",
  DATA_SUPPLIER = "dataSupplier",
  PRESENTER = "presenter",
  CATALOGUE_OWNER = "catalogueOwner"
}
